import { render, staticRenderFns } from "./my_task.vue?vue&type=template&id=2c6f0f63&"
import script from "./my_task.vue?vue&type=script&lang=js&"
export * from "./my_task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports